import styled from 'styled-components';

const SelectClient = styled.div`
  display: flex;
  flex-direction: column;
  p {
    color: ${({ theme }) => {
      return theme.colors.primary;
    }};
    font-size: ${({ theme }) => {
      return theme.fonts.size.normal;
    }};
    font-weight: ${({ theme }) => {
      return theme.fonts.weight.normal;
    }};
    margin-bottom: 5px;
  }
  select {
    box-sizing: border-box;
    height: 40px;
    width: 200px;
    border-radius: ${({ theme }) => {
      return theme.borderRadius.small;
    }};
    border: ${({ theme }) => {
      return theme.border;
    }};
    text-align: center;
    font-size: ${({ theme }) => {
      return theme.fonts.size.small;
    }};
    font-weight: ${({ theme }) => {
      return theme.fonts.weight.thin;
    }};
  }
`;

export default SelectClient;
